import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const LiveStream = loadable(() => pMinDelay(import('./LiveStream'), 300), {
  fallback: <Loading />
});

const AsyncLiveStream = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-solid-gray`
      },
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/video-js/video-js.min.css'
        }
      ],
    }
  };

  
  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LiveStream { ...props }/>
    </ApplicationLayout>
  );
};

AsyncLiveStream.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLiveStream;
